import { useState } from "react";
import { animated, useSpring } from "react-spring";
import { screens } from "../../../constants/constants";
import { springConfigs } from "../../../constants/springConfigs";
import { useMargins } from "../../../hooks/hooks";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { ArrowComponentMenu } from "../../shared/ArrowComponentMenu";
import { CaretAndBack } from "../../shared/CaretAndBack";
import { WhiteLine } from "../../shared/WhiteLine";

export const ScreenMenuArrowColum = ({
  active,
  setActive,
  screenTransition,
  screenTransitionDelay,
  onCurtainStart,
}: {
  active;
  setActive;
  screenTransition?;
  screenTransitionDelay?;
  onCurtainStart;
}) => {
  const [appear, appearSet] = useState(true);

  const { MenuColumnBackground } = useSpring({
    from: { MenuColumnBackground: "#0005" },
    to: {
      MenuColumnBackground: !appear ? "#0005" : "#0000",
    },
    config: springConfigs.backgroundTransitions,
    onRest: () => {
      if (appear) appearSet(false);
    },
  });

  const { w, h, horizontal } = useWindowSize();
  const { screenMenuVerticalPadding, screenMenuHorizontalPadding } =
    useMargins();

  // return <></>;
  return (
    <animated.div
      id="ScreenMenuArrowColum"
      style={{
        height: "100%",
        display: "grid",
        gridTemplate: `
        "row1 line" 35%
        "row2 line" 65%
        `,
        background: MenuColumnBackground,
      }}
    >
      {/* grid row 1 */}
      <div
        id="grid-row-1"
        {...{
          style: {
            gridArea: "row1",
            display: "grid",
            paddingLeft: screenMenuVerticalPadding,
            paddingTop: screenMenuHorizontalPadding,
            placeItems: "start",
          },
        }}
      >
        <CaretAndBack
          {...{
            onCurtainStart,
            curtainTo: screens.landing,
          }}
        />
      </div>
      {/* grid row 2 */}
      <div
        id="grid-row-2"
        style={{
          gridArea: "row2",
        }}
      >
        <ArrowComponentMenu
          {...{
            onClick: (left) => {
              if (left) {
                if (active <= 0) {
                  setActive(3);
                }
                if (active > 0) {
                  setActive((active - 1) % 4);
                }
              }
              if (!left) {
                setActive((active + 1) % 4);
              }
            },
          }}
        />
      </div>
      <WhiteLine />
    </animated.div>
  );
};
